// @flow
export const emailRegex = /[a-zA-Z0-9_\.\-]+\@[a-zA-Z0-9\-]+(\.+[a-zA-Z0-9]{2,4})+/;
export const decimalRegex = /[0-9]{0,}(\.([0-9][0-9])?)/;
export const oldOrderRegex = /^OR[A-Z]{2}\d{8,}$/;
export const orderRegex = /^TR[A-Z]{2}\d{8,}$/;
export const flightRegex = /^FL[A-Z]{2}\d{8,}$/;
export const urlRegex = /^(https?:\/\/|ftps?:\/\/)?([a-z0-9%\-]+\.){1,}([a-z0-9\-]+)?(:(\d{1,5}))?(\/([a-z0-9ÅMÅŽÕÑ\|\-._~:\/\?#\[\]@!$&'\(\)\*\+,;=%\ ]+)?)?$/i;
export const amazonUrlRegex = /^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?(amazon\.com)/i;
export const amazonSpainUrlRegex = /^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?(amazon\.es)/i;
export const ebayUrlRegex = /^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?(ebay\.com)/i;
export const cartLinksRegexes = [
  /^(.+)?\/gp\/cart(.+)?$/,
  /^(.+)?cart\.ebay(.+)?$/,
  /^(.+)?\/cart$/,
  /^(.+)?\/shop\/cart(.+)?$/,
  /^(.+)?\/shop\/bag(.+)?$/,
  /^(.+)?\/jcart$/,
  /^(.+)?\/my-bag$/,
  /^(.+)?\/checkout$/,
  /^(.+)?\/Cart-Show$/,
  /^(.+)?\/basket$/,
  /^(.+)?\/CheckoutCartView$/,
  /^(.+)?\/cartview$/,
  /^(.+)?\/shopcart\/shopcartDetail(.+)?$/,
  /^(.+)?\/shipping_cart\.html$/,
  /^(.+)?\/cart\/(.+)?$/,
  /^(.+)?\/ShoppingCart\.aspx$/,
  /^(.+)?\/checkouts\/(.+)?$/,
  /^(.+)?\/Checkout$/,
  /^(.+)?\/OrderItemDisplay$/,
  /^(.+)?\/cart\.jsp$/,
];

export function isIphone13(url: string, name: string): boolean {
  return url.startsWith('https://www.apple.com/shop/buy-iphone/iphone-13');
}

export function limitStringEllipsis(text: string = '', limit: number): string {
  return text.length > limit ? `${text.substr(0, limit)}...` : text;
}

export function oldOrderVerifier(text: string = ''): boolean {
  return oldOrderRegex.test(text);
}

export function orderVerifier(text: string = ''): boolean {
  return orderRegex.test(text);
}

export function flightVerifier(text: string = ''): boolean {
  return flightRegex.test(text);
}

export function urlVerifier(text: string = ''): boolean {
  // general pattern recognition https://regex101.com/r/RgKTA4/2
  const match = text.match(urlRegex);
  if (!match) {
    return false;
  }
  // validate TLD
  if (typeof match[3] !== 'string') {
    return false;
  }
  // we are going to leave this for now, we don't want to add extra size to our js bundle
  // if (tlds.indexOf(match[3].toLowerCase()) === -1) return false;

  // validate port
  // if (match[5] && (!isPort(match[5]))) return false;
  return true;
}

export function shoppingCartUrlVerifier(text: string = ''): boolean {
  for (const regex of cartLinksRegexes) {
    if (regex.test(text)) {
      return true;
    }
  }
  return false;
}

export function amazonSpainVerifier(text: string = ''): boolean {
  if (amazonSpainUrlRegex.test(text)) {
    return true;
  }
  return false;
}

export function formatToTwoDecimal(num: string): string {
  const parsed = parseFloat(num);
  if (isNaN(parsed)) {
    return '';
  }
  return parsed.toFixed(2);
}

export function repeatString(string: string, times: number) {
  let repeatedString = "";
  while (times > 0) {
    repeatedString += string;
    times--;
  }
  return repeatedString;
}

export function getFilePathExtension(path: string) {
  let filename = path.split('\\').pop().split('/').pop();
  return filename.substr((Math.max(0, filename.lastIndexOf('.')) || Infinity) + 1);
}



// WEBPACK FOOTER //
// ./src/utils/string/index.js